import { Form } from 'factorial-form'

class MultiFilterForm extends Form {
  constructor(values: {}) {
    super(values, {
      logic_operator: 'string',
    })
  }
}

export default MultiFilterForm
